import { Injectable, inject } from '@angular/core';
import { AuthUserMetadataProvider, UserMetadataProvider } from './user-metadata.provider';
import { UserMetadata } from './user-metadata';

@Injectable({
  providedIn: 'root',
})
export class UserMetadataService {
  private readonly provider: UserMetadataProvider = inject(AuthUserMetadataProvider);

  getUserMetadata(): UserMetadata {
    return this.provider.getCurrentUserMetadata() ?? { submittedByEmployeeId: null };
  }
}
